// extracted by mini-css-extract-plugin
export default {"square":"square_fd4237c82b19ba0e5a15"};